import { useDidUpdateEffect } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { useGetPlatformForFeed } from '../../../useGetPlatformForFeed';

export const useOnLangPlatformChange = (callback) => {
  const platform = useGetPlatformForFeed();
  const { language } = useI18n();

  useDidUpdateEffect(() => {
    callback();
  }, [platform, language]);
};
